export type ScreenParams = Record<string, unknown>;
const callbackIds = new WeakMap<object, number>();
let nextCallbackId = 0;
function stable(value: unknown): string {
  if (typeof value === 'function') {
    if (!callbackIds.has(value)) callbackIds.set(value, ++nextCallbackId);
    return `callback:${callbackIds.get(value)}`;
  }
  if (Array.isArray(value)) return `[${value.map(stable).join(',')}]`;
  if (value && typeof value === 'object') return `{${Object.keys(value).sort().map(key => `${JSON.stringify(key)}:${stable((value as ScreenParams)[key])}`).join(',')}}`;
  return JSON.stringify(value) ?? 'null';
}
export function screenIdentity(screenId: string, params?: ScreenParams): string | undefined {
  const existingDocument = params?.documentId != null && params.documentId !== '';
  if (screenId === 'documents.new' || screenId === 'warehouse.purchase-new' || screenId === 'warehouse.transfer-new') {
    return existingDocument ? `${screenId}:${stable(params)}` : undefined;
  }
  if (screenId === 'stock.card' && (!params?.code || params.new === true)) return undefined;
  if (screenId === 'accounts.card' && (!params?.code || params.new === true)) return undefined;
  return `${screenId}:${stable(params ?? {})}`;
}
